import React, { lazy, Suspense } from 'react';
import totalData from '../../json/data.json';

// Lazy load the DynamicForm component
const DynamicForm = lazy(() => import('../../components/DynamicForm/DynamicForm'));

const AddNewsPage = () => {
  const fields = totalData[19].AdminNews;
  const apiUrl = 'https://pranusha.vercel.app/news';
  const successRedirect = '/admin/News';

  return (
    <div>
      <Suspense fallback={<p>Loading form...</p>}>
        <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
      </Suspense>
    </div>
  );
};

export default AddNewsPage;
